// yup validation
import * as Yup from "yup";

// regex for email
// export const phoneRegExp =
// /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

// //change password
// export const passwordSchema = Yup.object().shape({
//   password: Yup.string()
//     .min(7, "Password must be at least 7 characters")
//     .required("Password is required"),
//   cPassword: Yup.string()
//     .required("Please confirm password")
//     .oneOf([Yup.ref("password")], "Password Mismatch"),
// });

//change password
export const changePasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(7, "Password must be at least 7 characters")
    .required("Password is required"),
  cPassword: Yup.string()
    .required("Please confirm password")
    .oneOf([Yup.ref("password")], "Password Mismatch"),
});

//new contact person
export const informationSchema = Yup.object().shape({
  partnerorganisationId: Yup.object().shape({
    label: Yup.string().required("This field is required").nullable(),
    value: Yup.string().required("This field is required").nullable(),
  }),
});

export const nervePostSchema = Yup.object().shape({
  title: Yup.string().required("This field is required"),
  // hospitalName: Yup.string().required("This field is required"),
  message: Yup.string().required("This field is required"),
})

export const loginSchema = Yup.object({
  username: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
});

export const riderSchema = Yup.object({
  first_name: Yup.string().required("This field is required"),
  last_name: Yup.string().required("This field is required"),
  bike_id: Yup.string().required("This field is required"),
  dispatch_id: Yup.string().required("This field is required"),
});

export const agentSchema = Yup.object({
  first_name: Yup.string().required("This field is required"),
  last_name: Yup.string().required("This field is required"),
  email: Yup.string().required("This field is required"),
  password: Yup.string().required("This field is required"),
  address: Yup.string().required("This field is required"),
});

export const newOrderSchema = Yup.object({
  reason: Yup.string().required("Please state a reason"),
  bloodComponent: Yup.string().required("This field is required"),
});

export const cancelOrderSchema = Yup.object({
  reason: Yup.string().required("This field is required"),
  // topic: Yup.object({
  //   label: Yup.string().required("This field is required"),
  //   value: Yup.string().required("This field is required"),
  // }),
});
